import React from 'react';
import clsx from 'clsx';
import { Grid } from '@mui/material';
import { ReadTextField } from '@icoach/components';
import { Card, Typography, Stack, CheckboxField } from "@curves/ui-base";

const ConfigurationOthersReadContent = React.forwardRef((props, ref) => {
    const { className: classNameProps, sourceData } = props;
    const {
        billingBankName = '', billingMerchantNo = '',
        ecPaySetting = {}, smsSetting = {}
    } = sourceData;

    return (
        <React.Fragment>
            <Card.CardContent className={clsx(classNameProps)}>
                <Typography className={'font-weight-medium'} variant={'h5'}>
                    批次扣款設定
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <ReadTextField label={'銀行'}>{billingBankName}</ReadTextField>
                    </Grid>
                    <Grid item xs={4}>
                        <ReadTextField label={'特店代號'}>{billingMerchantNo}</ReadTextField>
                    </Grid>
                </Grid>
            </Card.CardContent>
            <Card.CardContent className={clsx(classNameProps)}>
                <Typography className={'font-weight-medium'} variant={'h5'}>
                    電子發票設定
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <ReadTextField label={'商店代號'}>{ecPaySetting.merchantID}</ReadTextField>
                    </Grid>
                    <Grid item xs={4}>
                        <ReadTextField label={'帳號'}>{ecPaySetting.account}</ReadTextField>
                    </Grid>
                    <Grid item xs={4}>
                        <ReadTextField label={'密碼'}>{ecPaySetting.password}</ReadTextField>
                    </Grid>
                    <Grid item xs={4}>
                        <ReadTextField label={'HashKey'}>{ecPaySetting.hashKey}</ReadTextField>
                    </Grid>
                    <Grid item xs={4}>
                        <ReadTextField label={'HashIV'}>{ecPaySetting.hashIV}</ReadTextField>
                    </Grid>
                    <Grid item xs={12}>
                        <Stack direction={'column'} className="bg-info-light px-4 py-2 mb-4">
                            <CheckboxField key={`notify-mixed-${ecPaySetting.notifyMixed}`} defaultValue={[ecPaySetting.notifyMixed]}>
                                <CheckboxField.Checkbox value={true} label={'已設定發票開立通知為混合模式(電子郵件及手機簡訊)'} readOnly={true} />
                            </CheckboxField>
                        </Stack>
                    </Grid>
                </Grid>
            </Card.CardContent>
            <Card.CardContent className={clsx(classNameProps)}>
                <Typography className={'font-weight-medium'} variant={'h5'}>
                    簡訊發送設定
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <ReadTextField label={'帳號'}>{smsSetting.account}</ReadTextField>
                    </Grid>
                    <Grid item xs={4}>
                        <ReadTextField label={'密碼'}>{smsSetting.password}</ReadTextField>
                    </Grid>
                </Grid>
            </Card.CardContent>
        </React.Fragment>
    );
});

export default ConfigurationOthersReadContent;
